import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { getConsent, setConsent } from "../lib/analytics";

export const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
    const open = () => setVisible(true);
    window.addEventListener("gobax:open-consent", open);
    return () => window.removeEventListener("gobax:open-consent", open);
  }, []);

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
          data-testid="consent-banner"
          role="region"
          aria-label="Consentimento de cookies"
          className="glass fixed bottom-5 left-4 right-4 z-50 max-w-md rounded-2xl border border-white/12 p-6 shadow-2xl sm:left-6 sm:right-auto"
        >
          <h2 className="font-display text-sm font-bold uppercase tracking-[0.12em]">Privacidade e cookies</h2>
          <p className="mt-3 text-xs leading-relaxed text-gb-gray">
            Utilizamos tecnologias de mensuração (como Google Analytics, Tag Manager e Meta Pixel)
            somente após o seu consentimento, para entender a navegação e melhorar nossos serviços.
            Você pode alterar ou revogar esta escolha a qualquer momento em{" "}
            <strong className="text-gb-silverhi">Preferências de cookies</strong> no rodapé. Saiba mais na{" "}
            <Link to="/privacidade" className="text-gb-silverhi underline underline-offset-2">
              Política de Privacidade
            </Link>
            .
          </p>
          <div className="mt-5 flex gap-3">
            <button
              type="button"
              data-testid="consent-accept-btn"
              onClick={() => choose("granted")}
              className="btn-chrome flex-1 rounded-full px-4 py-2.5 text-xs font-semibold"
            >
              Aceitar
            </button>
            <button
              type="button"
              data-testid="consent-decline-btn"
              onClick={() => choose("denied")}
              className="btn-ghost-chrome flex-1 rounded-full px-4 py-2.5 text-xs font-semibold text-gb-white"
            >
              Recusar
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
